import { render, staticRenderFns } from "./QualificationsAdminMobileCard.vue?vue&type=template&id=f5b02f70&scoped=true"
import script from "./QualificationsAdminMobileCard.vue?vue&type=script&lang=js"
export * from "./QualificationsAdminMobileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b02f70",
  null
  
)

export default component.exports